package com.upcominds.expedite.model

import kotlinx.serialization.Serializable

@Serializable
data class Community(
    val id: String,
    val name: String,
    val description: String,
    val imageUrl: String,
    val area: String,
    val latitude: Double,
    val longitude: Double,
    val membersCount: Int
) {

    companion object {
        val sample = Community(
            id = "1",
            name = "Hiking Enthusiasts",
            description = "A community for people who love hiking and outdoor adventures.",
            imageUrl = "https://example.com/images/hiking_community.png",
            area = "Mountain Region",
            latitude = 34.0522,
            longitude = -118.2437,
            membersCount = 256
        )
    }
}